import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "alonePlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HomeListTitle = _resolveComponent("HomeListTitle");

  var _component_MvList = _resolveComponent("MvList");

  return _ctx.aloneList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 独家放送 "), _createVNode(_component_HomeListTitle, {
    title: "独家放送",
    routerPath: "/main/alone"
  }), _createCommentVNode(" 独家放送列表区域 "), _withDirectives(_createVNode(_component_MvList, {
    mvList: _ctx.aloneList,
    isUnderLine: true
  }, null, 8
  /* PROPS */
  , ["mvList"]), [[_vShow, _ctx.aloneList.length <= 4]])])) : _createCommentVNode("v-if", true);
}